import { render } from "./DRMirroringVMRemove.vue?vue&type=template&id=3dba0f42&scoped=true"
import script from "./DRMirroringVMRemove.vue?vue&type=script&lang=js"
export * from "./DRMirroringVMRemove.vue?vue&type=script&lang=js"

import "./DRMirroringVMRemove.vue?vue&type=style&index=0&id=3dba0f42&scoped=true&lang=scss"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dba0f42"]])

export default __exports__